import React, { Component } from 'react';
import { faPause, faCheck, faForward } from "@fortawesome/free-solid-svg-icons";
import { faDown } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import '../../css/agenttoolbar/agentstatus.css';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Button } from 'react-bootstrap';
import SignalRService from '../../controllers/SignalRService';
import Pause from './pause';
import AgentMenu from './agentmenu';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { notifyWithAction, removeNotification, seconds2HMS } from '../utils/utils';
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';
class AgentStatus extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showPauses: false,
            showSettings: false,
            time: "00:00:00",
            seconds: 0
        }
        this.login = this.login.bind(this);
        this.logout = this.logout.bind(this);
        this.pause = this.pause.bind(this);
        this.forward = this.forward.bind(this);
        this.toggleSettings = this.toggleSettings.bind(this);
        this.timer = null;
        this.count = this.count.bind(this);
        this.togglerRef = React.createRef();
    }

    componentDidMount() {
        SignalRService.getPausesList({ Extension: this.props.extension, UserId: this.props.userId }, x => { });
    }

    componentDidUpdate(prevProps, prevState) {

        if (!this.timer)
            this.timer = setInterval(this.count, 1000);

        if (this.props.phoneStatus?.party?.length > 0 && this.props.phoneStatus?.party !== prevProps.phoneStatus?.party &&
            this.props.phoneStatus?.heldCallGUID === null) {

            let partyName = this.props.partyName ? this.props.partyName : this.props.t("unknown")
            let notificationBody = this.props.party + "\n" + partyName + "\n";

            if (this.props.groupName)
                notificationBody += this.props.groupName + "\n";

            let actions = [];

            if (this.props?.functions?.answer) {
                actions.push({ action: 'answer', title: this.props.t("answer2") });
            }

            if (this.props?.functions?.hangup) {
                actions.push({ action: 'hangup', title: this.props.t("hungup2") });
            }

            if (!this.props?.phoneStatus?.inbound && this.props?.functions?.hangup)
                actions = [{ action: 'hangup', title: this.props.t("hungup2") }];

            notifyWithAction("Fidelity Agent: " + this.props.t("call"), notificationBody, `${window.location.origin}${window.location.pathname}/favicon.ico`, "call", actions);
        }

        if (this.props.status !== 'pause' && prevProps.status === "pause") {

            removeNotification("pause");
        }
        if ((this.props.status !== 'pause' && prevProps.status === "pause") ||
            (this.props.status === "pause" && prevProps.pause && this.props.pause.typeId !== prevProps.pause.typeId)) {

            localStorage.removeItem("faPauseStarted");
        }

        if (this.props.status === 'pause' && (prevProps.status !== "pause" ||
            (this.props.pause !== null && prevProps.pause && this.props.pause.typeId !== prevProps.pause.typeId))) {

            let pauseDateStr = localStorage.getItem("faPauseStarted");
            let seconds = 0;
            if (pauseDateStr) {
                let pauseDate = new Date(pauseDateStr);
                seconds = Math.round((new Date() - pauseDate) / 1000);
            } else {
                localStorage.setItem("faPauseStarted", new Date().toISOString());
            }

            if (this.props.pause.timeOut > 0 && !pauseDateStr) {
                let futureDate = new Date()
                futureDate = new Date(futureDate.setSeconds(futureDate.getSeconds() + (this.props.pause.timeOut * 60)))
                localStorage.setItem("faPauseStarted", futureDate.toISOString());
                this.setState({
                    seconds: parseInt(this.props.pause.timeOut * -60)
                });
            } else {
                this.setState({
                    seconds: seconds
                });
            }
        }

        if (this.props.status === 'wrapup' && prevProps.status !== "wrapup" && this.props.wrapUpTime > 0) {
            this.setState({
                seconds: parseInt(-this.props.wrapUpTime)
            });
        }
    }

    count() {

        let seconds = this.state.seconds,
            result = "00:00:00";

        if (this.props.status === 'pause' || this.props.status === 'wrapup') {

            if (this.props.status === 'pause') {
                let pauseDateStr = localStorage.getItem("faPauseStarted");
                if (pauseDateStr) {
                    let pauseDate = new Date(pauseDateStr);
                    seconds = Math.round((new Date() - pauseDate) / 1000);
                }
            }

            if (this.props.status === 'wrapup') {
                seconds += 1;
            }

            result = seconds2HMS(Math.abs(seconds))

        } else {
            seconds = 0;
            result = "00:00:00";
        }

        this.setState({
            time: result,
            seconds: parseInt(seconds)
        });

        if (seconds === 0) {
            clearInterval(this.timer);
            this.timer = null;
        }
    }

    logout(e) {
        e.preventDefault();
        SignalRService.logoutACD({ Extension: this.props.extension, UserId: this.props.userId }, x => { });
    }

    login(e) {
        e.preventDefault();
        SignalRService.loginACD({ Extension: this.props.extension, UserId: this.props.userId }, x => { });
    }

    pause(e) {
        //e.preventDefault();
        this.setState({ showPauses: !this.state.showPauses });
    }

    forward(e) {
        e.preventDefault();
        SignalRService.nextACD({ Extension: this.props.extension, UserId: this.props.userId }, x => { });
        //this.props.hideFormUrl();
    }

    toggleSettings(value) {
        this.setState({ showSettings: value });
    }

    render() {
        let logout = <Button variant="light" size='sm' onClick={this.logout}><FontAwesomeIcon icon={faDown} /></Button>,
            available = <Button variant="light" size='sm' onClick={this.login}><FontAwesomeIcon icon={faCheck} /></Button>,
            pause = <Button variant="light" size='sm' onClick={this.pause}><FontAwesomeIcon icon={faPause} /></Button>,
            forward = <Button variant="light" size='sm'><FontAwesomeIcon icon={faForward} /></Button>,
            photo = <div className='user-img'>{this.props.initials}</div>,
            statusText = this.props.t("logoutacd"),
            noLicense = this.props.phoneStatus === null || this.props.phoneStatus === "" || (this.props.phoneStatus !== null && this.props.phoneStatus.ctiStatus != null && this.props.phoneStatus.ctiStatus.toLowerCase() === 'notlicense');

        if (noLicense) {

            logout = <Button variant="light" size='sm' className='active-control'><FontAwesomeIcon icon={faDown} /></Button>;
            available = <Button variant="light" size='sm' className='active-control' ><FontAwesomeIcon icon={faCheck} /></Button>;
            pause = <Button variant="light" size='sm' className='active-control'><FontAwesomeIcon icon={faPause} /></Button>;
            forward = <Button variant="light" size='sm' className='active-control' ><FontAwesomeIcon icon={faForward} /></Button>;

        } else {

            if (this.props.status === "logout") {
                logout = <Button variant="secondary" size='sm'><FontAwesomeIcon icon={faDown} /></Button>;
                pause = <Button variant="light" size='sm' className='active-control' ><FontAwesomeIcon icon={faPause} /></Button>;
            }

            if (this.props.status === "pause") {
                pause = <Button variant="danger" size='sm' onClick={this.pause}><FontAwesomeIcon icon={faPause} /></Button>;
                statusText = `${this.props.t("pause")} ${this.props.pause.description} ${this.state.time}`;
            }

            if (["busy", "wrapup", "available"].indexOf(this.props.status) > -1) {
                available = <Button size='sm' variant="success"><FontAwesomeIcon icon={faCheck} /></Button>;
                forward = <Button size='sm' variant="light" onClick={this.forward}><FontAwesomeIcon icon={faForward} /></Button>;
                statusText = this.props.t("registered");
                if (this.props.status === "wrapup")
                    statusText = `${this.props.t("wrapup")} ${this.state.time}`;
            }
        }

        if (this.props.form !== null && this.props.form.trim() !== "" && this.props.status !== "pause" && this.props.status !== "wrapup")
            statusText = `${this.props.t("formopened")} ${this.state.time}`;

        if (this.props.photo)
            photo = <img src={`${this.props.photo}`} alt="profile" />

        return (
            <>
                <div className="d-flex align-items-center flex-row-auto" >
                    {
                        <div className="d-none d-md-flex flex-column align-items-end justify-content-center me-2 me-md-4" style={{ width: "100%" }}>
                            <span className="text-white opacity-75 fs-6 lh-1 mb-1">{this.props.t("status")}</span>
                            <span className={"fs-6 lh-1 "}>
                                {statusText}

                                {
                                    this.props.pause != null && this.state.seconds > 0 && this.props.pause.timeOut > 0 &&
                                    <OverlayTrigger
                                        placement="bottom"
                                        delay={{ show: 250, hide: 400 }}
                                        overlay={<Tooltip style={{ position: "fixed" }}>
                                            {this.props.t("pausetimeexceeded")}
                                        </Tooltip>}>
                                        <div style={{ display: "inline" }}><FontAwesomeIcon icon={duotone("triangle-exclamation")} /></div>
                                    </OverlayTrigger>

                                }

                            </span>
                            {
                                !noLicense &&
                                <span className={"text-white fs-6 lh-1 mt-1 "}>{this.props.phoneStatus ? this.props.t(this.props.phoneStatus.ctiStatus.toLowerCase()) : ""}</span>
                            }
                            {
                                noLicense &&
                                <span className={"text-white fs-6 lh-1 mt-1 text-danger"}>{this.props.t("notlicense")}</span>
                            }
                        </div>
                    }
                    <OverlayTrigger
                        placement="bottom"
                        delay={{ show: 250, hide: 400 }}
                        overlay={<Tooltip style={{ position: "fixed" }}>
                            {this.props.t("register")}
                        </Tooltip>}>
                        <div className="d-flex align-items-center ms-1">{available}</div>
                    </OverlayTrigger>
                    <OverlayTrigger
                        placement="bottom"
                        delay={{ show: 250, hide: 400 }}
                        overlay={<Tooltip style={{ position: "fixed" }}>
                            {this.props.t("logoutacd")}
                        </Tooltip>}>
                        <div className="d-flex align-items-center ms-1">{logout}</div>
                    </OverlayTrigger>
                    <OverlayTrigger
                        placement="bottom"
                        delay={{ show: 250, hide: 400 }}
                        overlay={<Tooltip style={{ position: "fixed" }}>
                            {this.props.t("pause")}
                        </Tooltip>}>
                        <div className="d-flex align-items-center ms-1">{pause}</div>
                    </OverlayTrigger>
                    <OverlayTrigger
                        placement="bottom"
                        delay={{ show: 250, hide: 400 }}
                        overlay={<Tooltip style={{ position: "fixed" }}>
                            {this.props.t("forcenext")}
                        </Tooltip>}>
                        <div className="d-flex align-items-center ms-1">{forward}</div>
                    </OverlayTrigger>
                    <div className="d-flex align-items-center ms-1">
                        <div ref={this.togglerRef} className="btn btn-flex align-items-center bg-hover-white bg-hover-opacity-10 py-2 px-2 px-md-3" onClick={e => { e.preventDefault(); this.toggleSettings(!this.state.showSettings) }}>
                            <div className="agent-data d-none d-md-flex flex-column align-items-end justify-content-center me-2 me-md-4">
                                <span className="text-white opacity-75 fs-5 lh-1 mb-1 agent-fullname">{this.props.name}</span>
                                <span className="text-white fs-5 lh-1">{this.props.shortExtension}</span>
                            </div>
                            <div className="symbol symbol-30px symbol-md-40px">
                                {photo}
                            </div>
                        </div>
                        <AgentMenu showSettings={this.state.showSettings} toggleSettings={this.toggleSettings} togglerRef={this.togglerRef}></AgentMenu>
                    </div>
                </div>
                <Pause show={this.state.showPauses} toggleModal={this.pause}></Pause>
            </>
        );
    };
}

const mapStateToProps = (state) => {
    return {
        name: state.agent.name,
        status: state.agent.status,
        shortExtension: state.agent.shortExtension,
        photo: state.agent.photo,
        initials: state.agent.initials,
        duple: state.agent.duple,
        extension: state.agent.extension,
        userId: state.agent.userId,
        pause: state.agent.pause,
        phoneStatus: state.agent.phoneStatus,
        party: state.agent.party,
        partyName: state.agent.partyName,
        groupName: state.agent.groupName,
        wrapUpTime: state.agent.wrapUpTime,
        functions: state.agent.functions
    };
};

export default compose(connect(mapStateToProps), withTranslation())(AgentStatus);